import _ from 'lodash';

import { MaybeNull, MaybeUndef } from '../../types/system';

export const normalize = (path?: string): string => {
  if (typeof path !== 'string') {
    return '';
  }

  return (path
    // remove / at the end
    .replace(/\/?$/, '')
    // add / at the beginning
    .replace(/^\/?/, '/'));
};

export const join = (...paths) => {
  return paths.map(normalize).join('').replace(/\/+/, '/');
};

export const basename = (path) => _(normalize(path)).split('/').last() || path;

export const toFoldersArray = (path: string): ArrayLike<string> =>
  _.chain(path).trim(' /').split('/').compact().value();

export const getParentFolder = (
  path: MaybeUndef<string>,
): MaybeNull<string> => {
  const parent = normalize(_(path).split('/').dropRight().join('/'));

  return parent !== path ? parent : null;
};

export interface FolderNameAndPath {
  name: string;
  path: string;
}

export function collectPaths(names: ArrayLike<string>): FolderNameAndPath[] {
  let currentPath = '';

  return _.map(names, (folderName: string) => {
    currentPath += `/${folderName}`;

    return {
      name: folderName,
      path: currentPath,
    };
  });
}
